import type { NextApiRequest } from 'next';

import {
  getCorrelationIdFromHeaders,
  getGuestIdFromHeaders,
  getSessionIdFromHeaders,
  getSoaTokenFromHeaders,
  getUserIdFromHeaders,
} from '@/utils/ebRequestHeaders';

export const PRIVATE_NO_STORE_CACHE_CONTROL = 'private, no-cache, no-store, must-revalidate';

const NUMERIC_ONLY = /^\d+$/;

export function getSoaTokenFromRequest(req: NextApiRequest): string {
  return getSoaTokenFromHeaders(req.headers) ?? '';
}

export function getCorrelationIdFromRequest(req: NextApiRequest): string {
  return getCorrelationIdFromHeaders(req.headers);
}

export function getUserIdFromRequest(req: NextApiRequest): string {
  return getUserIdFromHeaders(req.headers) ?? '';
}

export function getSessionIdFromRequest(req: NextApiRequest): string {
  return getSessionIdFromHeaders(req.headers) ?? '';
}

export function getGuestIdFromRequest(req: NextApiRequest): string {
  return getGuestIdFromHeaders(req.headers) ?? '';
}

export function isNonEmptyString(value: unknown): value is string {
  return typeof value === 'string' && value.trim() !== '';
}

export function parseNumericId(value: unknown): string | null {
  if (typeof value !== 'string') {
    return null;
  }

  const trimmed = value.trim();
  if (!NUMERIC_ONLY.test(trimmed)) {
    return null;
  }

  const numericValue = Number(trimmed);
  if (!Number.isFinite(numericValue) || numericValue <= 0) {
    return null;
  }

  return trimmed;
}

export function isPositiveNumericId(value: string): boolean {
  return typeof value === 'string' && !!Number(value) && Number(value) > 0;
}
